import { randomUUID } from "./randomId";

export const REACH_VIEWER_STORAGE_KEY = "gitcha-reach-viewer";

const VALID_KEY = /^[A-Za-z0-9_-]{16,64}$/;

let memoryEntry = null;

export const utcDay = (now = new Date()) => now.toISOString().slice(0, 10);

const readStored = (storage) => {
  try {
    const raw = storage && storage.getItem(REACH_VIEWER_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const isCurrent = (entry, day) =>
  Boolean(entry && entry.day === day && VALID_KEY.test(entry.key || ""));

const defaultStorage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const getReachViewerKey = ({
  storage = defaultStorage(),
  now = new Date(),
} = {}) => {
  const day = utcDay(now);
  const stored = readStored(storage);
  if (isCurrent(stored, day)) return stored.key;
  if (isCurrent(memoryEntry, day)) return memoryEntry.key;
  const entry = { day, key: randomUUID() };
  memoryEntry = entry;
  try {
    if (storage) storage.setItem(REACH_VIEWER_STORAGE_KEY, JSON.stringify(entry));
  } catch {
    return entry.key;
  }
  return entry.key;
};

export const resetReachViewerMemory = () => {
  memoryEntry = null;
};

const originOf = (value) => {
  try {
    return value ? new URL(value).origin : null;
  } catch {
    return null;
  }
};

export const getEmbedParentOrigin = (win = typeof window !== "undefined" ? window : null) => {
  if (!win) return null;
  try {
    const ancestors = win.location && win.location.ancestorOrigins;
    if (ancestors && ancestors.length) return originOf(ancestors[0]);
  } catch {
    return null;
  }
  try {
    return originOf(win.document && win.document.referrer);
  } catch {
    return null;
  }
};
